import React, { useState, useEffect } from "react";
import { Link } from "react-router-dom";
import "../Styles/NavBar.css";
import * as FaIcons from "react-icons/fa";
import { SidebarMap } from "./SidebarMap";
import { IconContext } from "react-icons/lib";

function NavBar() {
  const [sidebar, setSidebar] = useState(false);
  const [activeCategory, setActiveCategory] = useState(null); 

  const showSidebar = () => {
    setSidebar(!sidebar);
  };

  const handleLinkClick = () => {
  
    if (sidebar) {
      setSidebar(false); 
    }
  };

  const handleCategoryClick = (categoryIndex) => {
    setActiveCategory(activeCategory === categoryIndex ? null : categoryIndex); 
  };

  useEffect(() => {
    const Sidebar = document.querySelector(".nav-menu");
    const handleClickOutside = (e) => {
      if (!sidebar || !Sidebar.contains(e.target)) {
        setSidebar(false);
      }
    };
    document.addEventListener("mouseup", handleClickOutside);
    return () => {
      document.removeEventListener("mouseup", handleClickOutside);
    };
  }, [sidebar]);

  useEffect(() => {
    const handleScroll = () => {
      const navbar = document.querySelector(".navbar");
      if (window.pageYOffset > 0) {
        navbar.classList.add("scrolled");
      } else {
        navbar.classList.remove("scrolled");
      }
    };

    window.addEventListener("scroll", handleScroll);
    return () => window.removeEventListener("scroll", handleScroll);
  }, []);

  useEffect(() => {
    if (sidebar) {
      document.body.style.overflow = "hidden";
    } else {
      document.body.style.overflow = "initial";
    }
  }, [sidebar]);

  return (
    <IconContext.Provider value={{ color: "white" }}>
      <div className="navbar">
        <p>PJ</p>
        
   
        {!sidebar && (
          <Link to="#" className="menu-bars">
            <FaIcons.FaBars color="white" onClick={showSidebar} />
          </Link>
        )}

        <nav className={sidebar ? "nav-menu active" : "nav-menu"}>
          <ul className="nav-menu-items">
            <div className="nav-title">
              <h3>Menu</h3>
            </div>

            <li className="nav-text-home">
              <Link to="/" onClick={handleLinkClick}>
                <FaIcons.FaHome />
              </Link>
            </li>

         
            {SidebarMap.map((category, categoryIndex) => (
              <div key={categoryIndex}>
                <div
                  className="nav-category"
                  onClick={() => handleCategoryClick(categoryIndex)}
                >
                  <h4>{category.category}</h4>
                  <span className="dropdown-icon">
                    {activeCategory === categoryIndex ? (
                      <FaIcons.FaAngleUp />
                    ) : (
                      <FaIcons.FaAngleDown />
                    )}
                  </span>
                </div>
                <div
                  className={`category-items ${activeCategory === categoryIndex ? 'active' : ''}`}
                >
                  {category.items.map((item, index) => (
                    <li key={index} className={item.cName}>
                      <Link to={item.path} onClick={handleLinkClick}>
                        {item.icon}
                        <span>{item.title}</span>
                      </Link>
                    </li>
                  ))}
                </div>
              </div>
            ))}
          </ul>
        </nav>
      </div>
    </IconContext.Provider>
  );
}

export default NavBar;
